export enum EMode {
  MONOCHROME = "0",
  COLORS = "1",
}
